module.exports = __webpack_public_path__ + "media/11_1.7bc2609b.wav";